// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3Uv0K","balanceDisclaimer":"posDashboard_balanceDisclaimer__C8ONs"};